// extracted by mini-css-extract-plugin
export var colorSquare = "_pu-0";
export var danger = "_pu-5";
export var lightPink = "_pu-8";
export var neutralBlue = "_pu-7";
export var neutralYellow = "_pu-6";
export var normal = "_pu-1";
export var primary = "_pu-2";
export var primaryLight = "_pu-3";
export var solidBlack = "_pu-g";
export var solidGreen = "_pu-b";
export var solidLightBlue = "_pu-d";
export var solidNavy = "_pu-c";
export var solidOrange = "_pu-f";
export var solidPink = "_pu-e";
export var solidRed = "_pu-9";
export var solidYellow = "_pu-a";
export var success = "_pu-4";